const React = require('react');
const {FormWrapper, FormFooter} = require('../../../../../dumb/FormHandlers');
const {AdminFormCol, AdminFormRow} = require('../../../../../dumb/AdminHelpers/AdminLayout');
const {AdminInput, AdminInputPassword, AdminCheckbox, AdminSelect} = require("../../../../../dumb/FormInputs");
const schemaUserData = require('./utils/schemaUserData');

const {apiAdminMerchantAccountCreate} = require("../../../../../../api/admin/retailersCreate");
const {pushLocation} = require("../../../../../../router");
const {getAdminRetailersLink} = require("../../../../../../utils/adminLinkCtor");
const {LINK_ADMIN_ADD} = require("../../../../../../constants/links");


module.exports = ({close}) => {
  return (
    <FormWrapper
      schema={schemaUserData}
      onSubmit={(props) => (
        apiAdminMerchantAccountCreate(props)
      )}
      onResult={({account_id}) => {
        pushLocation({
          path: getAdminRetailersLink(LINK_ADMIN_ADD + `?userId=${account_id}`)
        });
        close();
      }}
    >{(formCtx) => {
        return (
          <>
            <AdminFormRow>
              <AdminFormCol>
                <AdminInput
                  name="company_name"
                  label="Retailer Name"
                  formCtx={formCtx}
                />
              </AdminFormCol>
              <AdminFormCol>
                <AdminSelect
                  propName="name"
                  propValue="id"
                  items={[
                    {id: 'merchant', name: 'Merchant'},
                    {id: 'partner', name: 'Partner'}
                  ]}

                  name="role"
                  label="Retailer Role"
                  formCtx={formCtx}
                />
              </AdminFormCol>
              <AdminFormCol>
                <AdminInput
                  name="login"
                  label="Login"
                  formCtx={formCtx}
                />
              </AdminFormCol>
              <AdminFormCol>
                <AdminInputPassword
                  name="password"
                  label="Password"
                  formCtx={formCtx}

                  autoComplete="new-password"
                />
              </AdminFormCol>
            </AdminFormRow>
            <FormFooter
              submitBtnData={{
                text: 'Create New User',
                testId: 'submitNewRetailerData',
                formCtx
              }}
              additionalBtnsList={[
                {text: 'Cancel', onClick: close},
              ]}
            />
          </>
        )
    }}</FormWrapper>
  )
}
